import { Button } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { consentNeeded } from '../utils/helpers';
import { useSelfServiceData } from '../utils/useSelfServiceData';
import { SelfServicePath } from '../SelfServiceRoutes';
import './styles.less';

const Enroll: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data } = useSelfServiceData();

  const navigateTo = () => {
    const consentInfo = data?.consentInfos[0];
    if (consentInfo && consentNeeded(consentInfo)) {
      navigate(`/self-service${SelfServicePath.SELF_SERVICE_CONSENT_FACE}`);
    } else {
      //enroll
    }
  };

  return (
    <div className="enroll-content">
      <div className="enroll-text">
        <h2 className="enroll-title">{t('self-service.enroll.title')}</h2>
        <p>{t('self-service.enroll.description')}</p>
      </div>
      <div className="enroll-buttons">
        <Button type="primary" onClick={navigateTo}>
          {t('common.continue-button')}
        </Button>
        <Button type="text">{t('self-service.enroll.later')}</Button>
      </div>
    </div>
  );
};

export default Enroll;
